import { ArrowRight, ClipboardList } from "lucide-react";
import { Reveal } from "./Reveal";

const FLOW = [
  "20-question self-assessment",
  "Initial understanding",
  "Consultation booking",
  "Detailed assessment form after booking",
  "Reviewed within your pathway",
];

export default function BrainTypeCta({ onOpen }) {
  return (
    <section id="brain-type-assessment" data-testid="brain-type-cta-section" className="bg-[#FAF7F2] pb-16 lg:pb-28 -mt-16 lg:-mt-28 pt-0">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 lg:pt-28">
        <Reveal>
          <div className="bg-[#F7EFE9] border border-[#E5D3AD]/60 rounded-3xl p-8 lg:p-12 text-center relative overflow-hidden">
            <div className="pointer-events-none absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#C5A059]/10 blur-3xl" />
            <div className="mx-auto w-14 h-14 rounded-full bg-[#1B3B2B] flex items-center justify-center">
              <ClipboardList className="w-6 h-6 text-[#C5A059]" />
            </div>
            <h3 className="mt-6 font-serif text-2xl sm:text-3xl lg:text-4xl text-[#1B3B2B] tracking-tight">
              Curious About Your Child's Brain Type?
            </h3>
            <p className="mt-4 text-sm sm:text-base text-[#5C6E62] max-w-xl mx-auto leading-relaxed">
              Take our 20-question self-assessment to explore the basic patterns of your child's brain type.
            </p>
            <button
              data-testid="take-assessment-btn"
              onClick={onOpen}
              className="mt-7 bg-[#1B3B2B] text-[#FAF7F2] font-semibold tracking-wide text-sm px-9 py-4 rounded-full hover:bg-[#132C20] transition-all duration-300 hover:-translate-y-0.5 shadow-[0_12px_32px_rgb(27,59,43,0.2)]"
            >
              TAKE THE 20-QUESTION ASSESSMENT
            </button>
            <p className="mt-4 text-[11px] text-[#8a968e] max-w-md mx-auto leading-relaxed">
              A preliminary self-evaluation for educational purposes only — not a medical diagnosis or definitive
              assessment. Your detailed assessment is completed after booking your consultation.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-[11px] text-[#5C6E62]">
              {FLOW.map((f, i) => (
                <span key={f} className="flex items-center gap-2">
                  <span className="bg-[#FAF7F2] border border-[#E5D3AD] rounded-full px-3.5 py-1.5">{f}</span>
                  {i < FLOW.length - 1 && <ArrowRight className="w-3.5 h-3.5 text-[#C5A059]" />}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
